/**
 * Court uploader status is used to communicate court uploader
 * behaviour. For example, a court uploader may have its status set as
 * disabled, which would mean all court uploader clients for that repository
 * would do nothing when launched.
 *
 * Note that court uploader status exists on both a repository and its clients.
 */
export var CourtUploaderStatus;
(function (CourtUploaderStatus) {
    /**
     * Court uploader clients should only scan the file system for new files
     */
    CourtUploaderStatus["Scanning"] = "scanning";
    /**
     * Court uploader clients should only upload queued files from the filesystem,
     * which means new files aren't going to be detected by the scanning process
     */
    CourtUploaderStatus["Uploading"] = "uploading";
    /**
     * Court uploader clients should both scan for new files and upload files
     * found through scanning
     */
    CourtUploaderStatus["ScanningAndUploading"] = "scanning and uploading";
    /**
     * Court uploader clients should do nothing
     */
    CourtUploaderStatus["Disabled"] = "disabled";
})(CourtUploaderStatus || (CourtUploaderStatus = {}));
